module.exports = __webpack_public_path__ + "static/media/periscope.7574d3be.png";